/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The styled components for Category Chart
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.3.1
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../../theme';


export const ChartCategoryStyled = styled.div.attrs({
    'className': 'chart chart_category',
    'data-module': 'chartCategory',
})`
    position: relative;
    width: 100%;

    /*
    * -------------------------------------------
    *           TOOLTIP
    * -------------------------------------------
    */

    .chart-category__tooltip {
        position: absolute;
        width: 320px;
        padding: 20px;
        box-sizing: border-box;
        box-shadow: 0 2px 12px 0 rgba(51, 51, 51, 0.2);
        background: ${colors.backgroundColorWhite};
        pointer-events: none;
        z-index: 11;

        .tooltip__title-date {
            margin-bottom: 8px;
            ${fonts.textMainBold};
            text-transform: capitalize;
        }

        .tooltip__title-info {
            display: flex;
            ${fonts.textSmall};

            .title-info__number {
                margin-right: 4px;
                white-space: nowrap;
            }

            .title-info__city {
                color: ${colors.textColorOpacity};
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .tooltip__total {
            display: flex;
            justify-content: space-between;
            margin: 24px 0 12px;
            ${fonts.textSmall};
        }

        .tooltip__items {
            list-style-type: none;
            padding: 0;
            margin: 0;
            ${fonts.textSmall};

            .tooltip__item {
                display: flex;
                align-items: center;
                margin-bottom: 12px;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .tooltip__item-color {
                display:inline-block;
                min-width: 8px;
                width:8px;
                height:8px;
                border-radius:50%;
                margin-right:8px;
            }

            .tooltip__item-name {
                flex-grow: 1;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .tooltip__item-price {
                flex-shrink: 0;
                margin-left: 8px;
                text-align: right;
            }
        }
    }
`;
